import React from "react";
import ImageWithLoader from "../../components/ImageWithLoader";

const CrateImage = ({ img }) => {
  return <ImageWithLoader img={img} alt={"crate-image"} />;
};

export default CrateImage;
